export { default } from './WindStationCardPlaceholder';
